import { ThemeColors } from '../../../'

export interface SearchInputColors {
  Background: ThemeColors
  Border: ThemeColors
  BoxShadow_Selected: ThemeColors
  FontColor: {
    Placeholder: ThemeColors
  }
  Icons: {
    Search: ThemeColors
    Clear: {
      Stroke: ThemeColors
      Fill: ThemeColors
    }
  }
}

export const searchInputColors: SearchInputColors = {
  Background: {
    default: 'bg.panel',
  },
  Border: {
    default: 'border.default',
  },
  BoxShadow_Selected: {
    default: 'brand.muted',
  },
  FontColor: {
    Placeholder: {
      default: 'fg.muted',
    },
  },
  Icons: {
    Search: {
      default: 'fg.muted',
    },
    Clear: {
      Stroke: {
        default: 'fg.inverted',
      },
      Fill: {
        default: 'fg.default',
      },
    },
  },
}
